module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.visibleForm) ? _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('div', {
    staticClass: "fade-transition ng-scope",
    attrs: {
      "ng-view": ""
    }
  }, [_c('section', {
    staticClass: "content-header ng-scope"
  }, [_c('vue-headful', {
    attrs: {
      "title": 'SGP - Solicitações'
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Solicitações")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": _vm.breadcrumb
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content ng-scope"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(((_vm.usuarioLogado.userType !== 'FUNDACAO') && _vm.possuiProcessoEmRevisao)) ? _c('div', {
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ng-scope ng-isolate-scope"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row collapse in",
    staticStyle: {
      "width": "inherit",
      "height": "auto"
    },
    attrs: {
      "aria-expanded": "true",
      "aria-hidden": "false"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "btn-group dropdown"
  }, [(_vm._.find(_vm._.get(_vm.usuarioLogado, 'configuracoes.acesso_projetos', [{
    'acesso': [{
      'codigo': 'INICIA_SOLICITACAO'
    }]
  }]), function(p) {
    return _vm._.find(p.acesso, function(a) {
      return _vm._.includes(['INICIA_SOLICITACAO'], a.codigo)
    })
  })) ? _c('div', {
    staticClass: "btn-group"
  }, [(!_vm.ehParceiroEstrategico) ? _c('g-button-ujarak', {
    attrs: {
      "color": "dark-primary",
      "size": "button--size-ss",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Nova Solicitação ")]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [(_vm.$root.authorize('solicitacao-pagamento-editar') && !_vm.todasPropostasSimplificadas) ? _c('li', {
    staticClass: "ng-scope",
    attrs: {
      "role": "menuitem"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'solicitacao-pagamento',
        params: {
          visualizacao: false
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Pagamento")])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.authorize('solicitacao-pagamento-editar') && !_vm.todasPropostasSimplificadas) ? _c('li', {
    staticClass: "ng-scope",
    attrs: {
      "role": "menuitem"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'solicitacao-ressarcimento',
        params: {
          visualizacao: false
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Ressarcimento")])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.authorize('solicitacao-adiantamento-editar')) ? _c('li', {
    staticClass: "ng-scope",
    attrs: {
      "role": "menuitem"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'solicitacao-adiantamento'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Adiantamento")])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.authorize('solicitacao-prestacaocontas-editar') && !_vm.todasPropostasSimplificadas) ? _c('li', {
    staticClass: "ng-scope",
    attrs: {
      "role": "menuitem"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'solicitacao-prestacaocontas',
        params: {
          visualizacao: false
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Prestação de Contas")])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.authorize('solicitacao-devolucaoadiantamento-editar')) ? _c('li', {
    staticClass: "ng-scope",
    attrs: {
      "role": "menuitem"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'solicitacao-devolucao-adiantamento'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Devolução de Adiantamento")])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.authorize('solicitacao-contrapartida-editar')) ? _c('li', {
    staticClass: "ng-scope",
    attrs: {
      "role": "menuitem"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'solicitacao-contrapartida',
        params: {
          visualizacao: false
        }
      },
      "href": "javascript:void(0)"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Contrapartida")])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.authorize('solicitacao-contrapartida-editar')) ? _c('li', {
    staticClass: "ng-scope",
    attrs: {
      "role": "menuitem"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'solicitacao-alteracoes-projeto',
        params: {
          visualizacao: false
        }
      },
      "href": "javascript:void(0)"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" Alterações em projeto")])], 1) : _vm._e()])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-offset-1 col-sm-4",
    staticStyle: {
      "margin-bottom": "1rem"
    }
  }, [_c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'fade',
        distance: '1',
        size: 'large',
        placement: 'top'
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', placement: 'top'}"
    }],
    staticClass: "input-group",
    attrs: {
      "title": '<h5 class=\'text-left\'>Pesquise por partes da informação ou combinação deles. Exemplos:<ul><li>Número ou parte do nome do projeto<li>Um ou mais tipos de solicitação<li>Situação da solicitação<li>Data, valor etc</ul></h5>'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa),
      expression: "pesquisa"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa...",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.pesquisa)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onSearch($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pesquisa = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.onSearch()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" ")])])])]), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.situacaoFiltro),
      expression: "situacaoFiltro"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.situacaoFiltro = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.filtrarSituacao]
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Situação")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FEITO"
    }
  }, [_vm._v("Feito")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CANCELADO"
    }
  }, [_vm._v("Cancelado")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "EM_EXECUCAO"
    }
  }, [_vm._v("Em Execução")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TODOS"
    }
  }, [_vm._v("Todos")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'fade',
        distance: '1',
        size: 'large',
        interactive: true,
        theme: 'light',
        position: 'top',
        maxWidth: '600px'
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'fade', distance:'1', size: 'large', interactive: true, theme: 'light', position: 'top', maxWidth: '600px'}"
    }],
    staticClass: "legenda",
    attrs: {
      "title": '<table>' +
        '<tr class=\'' + (_vm.usuarioLogado.userType !== 'FUNDACAO' ? 'hidden' : '') + '\'><td style=\'padding: 10px\'><span class=\'btn-primary\' style=\'font-size: 12px;padding: 10px;border-radius: 2px !important;width: 100px;float: right;\'><i class=\'fa fa-gavel\'></i> Validar</span></td><td style=\'font-size: 14px;text-align: left; padding: 10px; width: 480px\'>Atribui o processo a você e abre a solicitação para validação da tarefa.</td></tr>' +
        '<tr><td style=\'padding: 10px\'><span class=\'button--moema warning\' style=\'font-size: 12px;padding: 10px;border-radius: 2px !important;width: 100px;float: right;\'><i class=\'fa fa-pencil-square-o\'></i> Revisar</span></td><td style=\'font-size: 14px;text-align: left; padding: 10px; width: 480px\'>Disponível a entidade para que revise a solicitação</td></tr>' +
        '<tr class=\'' + (_vm.usuarioLogado.userType !== 'FUNDACAO' ? 'hidden' : '') + '\'><td style=\'padding: 10px\'><span class=\'btn-primary\' style=\'font-size: 12px;padding: 10px;border-radius: 2px !important;width: 100px;float: right;\'><i class=\'fa fa-undo\'></i> Reanalisar</span></td><td style=\'font-size: 14px;text-align: left; padding: 10px; width: 480px\'>Volta o processo para Análise se ele estiver na Autorização, mas ainda não atribuído ao gerente.</td></tr>' +
        '<tr class=\'' + (_vm.usuarioLogado.userType !== 'FUNDACAO' ? 'hidden' : '') + '\'><td style=\'padding: 10px\'><span class=\'btn-primary\' style=\'font-size: 12px;padding: 10px;border-radius: 2px !important;width: 100px;float: right;\'><i class=\'fa fa-repeat\'></i> Retornar tarefa FBB</span></td><td style=\'font-size: 14px;text-align: left; padding: 10px; width: 480px\'>Volta o processo para Análise FBB quando ele está Em Revisão pela Entidade.</td></tr>' +
        '<tr class=\'' + (_vm.usuarioLogado.userType !== 'FUNDACAO' ? 'hidden' : '') + '\'><td style=\'padding: 10px\'><span class=\'btn-primary\' style=\'font-size: 12px;padding: 10px;border-radius: 2px !important;width: 100px;float: right;\'><i class=\'fa fa-backward\'></i> Retornar Entidade</span></td><td style=\'font-size: 14px;text-align: left; padding: 10px; width: 480px\'>Volta o processo para Revisão pela Entidade quando ele está em Análise pela FBB.</td></tr>' +
        '<tr><td style=\'padding: 10px\'><span class=\'btn-danger\'  style=\'font-size: 12px;padding: 10px;border-radius: 2px !important;width: 100px;float: right;\'><i class=\'fa fa-times-circle\'></i> Cancelar</span></td><td style=\'font-size: 14px;text-align: left; padding: 10px; width: 480px\'>Cancela o processo atual e ele não será considerado no saldo do projeto</td></tr>' +
        '<tr class=\'' + (_vm.usuarioLogado.userType !== 'FUNDACAO' ? 'hidden' : '') + '\'><td style=\'padding: 10px\'><span class=\'button--moema warning\' style=\'font-size: 12px;padding: 10px;border-radius: 2px !important;width: 100px;float: right;\'><i class=\'fa fa-play\'></i> Reativar</span></td><td style=\'font-size: 14px;text-align: left; padding: 10px; width: 480px\'>Se a solicitação estiver concluída, ela voltará para a execução na tarefa de Análise.</td></tr>' +
        '<tr><td style=\'padding: 10px\'><span class=\'button--moema success\' style=\'font-size: 12px;padding: 10px;border-radius: 2px !important;width: 100px;float: right;\'><i class=\'fa fa-search\'></i> Visualizar</span></td><td style=\'font-size: 14px;text-align: left; padding: 10px; width: 480px\'>Abre janela para visualizar a solicitação feita ou cancelada</td></tr>' +
        '<tr class=\'' + ((_vm.usuarioLogado.userType !== 'FUNDACAO' && !_vm.ehParceiroEstrategico) ? 'hidden' : '') + '\'><td style=\'padding: 10px\'><span class=\'btn-primary\' style=\'font-size: 12px;padding: 10px;border-radius: 2px !important;width: 40px;float: right;\'><i class=\'fa fa-download\'></i></span></td><td style=\'font-size: 14px;text-align: left; padding: 10px; width: 480px\'>Fará download de um arquivo ZIP contendo todos os arquivos anexados na solicitação.</td></tr>' +
        '<tr><td style=\'padding: 10px\'><span class=\'info\' style=\'font-size: 12px;padding: 10px;border-radius: 2px !important;width: 50px;float: right; color: #fff;\'>NF-e</span></td><td style=\'font-size: 14px;text-align: left; padding: 10px; width: 480px\'>Indica qual processo contém uma NF-e e permite fazer download em formato JSON</td></tr>' +
        '</table>'
    }
  }, [_vm._v("\n                Legenda\n              ")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "bordered": _vm.bordered,
      "items": _vm.items,
      "striped": "",
      "hover": "",
      "fields": _vm.fields,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "filter": _vm.table.filter,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "empty-text": "Faça uma pesquisa acima",
      "table-layout:": "",
      "fixed": ""
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "data_solicitacao",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
      }
    }, {
      key: "valor",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("real")(parseFloat(row.value))))]
      }
    }, {
      key: "situacao",
      fn: function(row) {
        return [_vm._v(_vm._s(row.value) + " "), _c('br'), _c('span', {
          domProps: {
            "innerHTML": _vm._s(row.item.info)
          }
        })]
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [(row.item.id && !_vm.ehParceiroEstrategico) ? _c('div', [(row.item.situacao !== 'Cancelado' && row.item.situacao !== 'Feito' && row.item.etapa === 'Revisão pela entidade') ? _c('g-button-ujarak', {
          attrs: {
            "color": "warning",
            "size": "button--size-ss",
            "disabled": !_vm.authorizeEditRequest(row.item) || row.item.etapa !== 'Devolvido' || !_vm.chiefActive
          },
          nativeOn: {
            "click": function($event) {
              return _vm.revisar(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Revisar\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'ENTIDADE' && row.item.situacao !== 'Cancelado' && row.item.situacao !== 'Feito' && row.item.etapa === 'Análise' && row.item.id_usuario === null) ? _c('g-button-ujarak', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large'
            }),
            expression: "{inertia: true, arrow: true, animation: 'perspective', distance: '1', size: 'large'}"
          }, {
            name: "confirm",
            rawName: "v-confirm",
            value: ({
              ok: function (retorno) { return _vm.revisaoEntidadeTarefa(retorno, row.item); },
              cancel: _vm.doNothing,
              message: 'Deseja <b>Revisar </b> a solicitação de ' + '<font color=red>' + row.item.tipo_solicitacao + '</font>?' + '<br><br>' +
                '- ID: ' + '<i><font color=#00008b>' + row.item.id + '</font></i>' + '<br>' + '- Projeto: ' + '<i><font color=#00008b>' + row.item.projeto + '</font></i>'
            }),
            expression: "{ok: retorno => revisaoEntidadeTarefa(retorno, row.item), cancel: doNothing, \n                          message: 'Deseja <b>Revisar </b> a solicitação de ' + '<font color=red>' + row.item.tipo_solicitacao + '</font>?' + '<br><br>'\n                          + '- ID: ' + '<i><font color=#00008b>' + row.item.id + '</font></i>' + '<br>' + '- Projeto: ' + '<i><font color=#00008b>' + row.item.projeto + '</font></i>'}"
          }],
          attrs: {
            "color": "primary",
            "size": "button--size-ss",
            "disabled": !_vm.authorizeEditRequest(row.item) || (row.item.etapa !== 'Devolvido' && row.item.etapa !== 'Análise') || !_vm.chiefActive,
            "type": "button",
            "title": '<h6 style=\'text-align: left\'>A tarefa será encaminhada para Revisão pela Entidade</h6>'
          }
        }, [_c('i', {
          staticClass: "fa fa-backward",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Retornar Entidade\n                      ")]) : _vm._e(), _vm._v(" "), (row.item.situacao === 'Em Execução' && row.item.etapa === 'Solicitação') ? _c('g-button-ujarak', {
          attrs: {
            "color": "primary",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.revisar(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Editar\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType !== 'ENTIDADE' && row.item.etapa === 'Revisão pela entidade' && row.item.situacao != 'Cancelado' && !_vm._.includes(['Alterações do Projeto'], row.item.tipo_solicitacao)) ? _c('g-button-ujarak', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large',
              arrow: true
            }),
            expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
          }, {
            name: "confirm",
            rawName: "v-confirm",
            value: ({
              ok: function (retorno) { return _vm.segueRetornarTarefa(retorno, row.item); },
              cancel: _vm.doNothing,
              message: 'Deseja <b>Retornar para a FBB</b> a solicitação de ' + '<font color=' + 'red' + '>' + row.item.tipo_solicitacao + '</font>' + '? <br><br> - ID: ' + '<i>' + '<font color=' + '#00008b' + '>' + row.item.id + '</font>' + '</i>' +
                '<br> - Projeto: ' + '<i>' + '<font color=' + '#00008b' + '>' + row.item.projeto + '</font>' + '</i>' + '</i>'
            }),
            expression: "{ok: retorno => segueRetornarTarefa(retorno, row.item), cancel: doNothing,\n                                        message: 'Deseja <b>Retornar para a FBB</b> a solicitação de ' + '<font color=' + 'red' + '>' + row.item.tipo_solicitacao + '</font>' + '? <br><br> - ID: ' + '<i>' + '<font color=' + '#00008b' + '>' + row.item.id + '</font>' + '</i>'\n                                         + '<br> - Projeto: ' + '<i>'  + '<font color=' + '#00008b' + '>' + row.item.projeto + '</font>' + '</i>' + '</i>'}"
          }],
          attrs: {
            "color": "dark-primary",
            "size": "button--size-ss",
            "type": "button",
            "title": '<h6 style=\'text-align: left\'>' + 'A tarefa está Em Revisão pela entidade e será retornada para Análise da FBB' + '</h6>'
          },
          nativeOn: {
            "click": function($event) {
              return _vm.segueRetornarTarefa(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-repeat",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Retornar tarefa FBB\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.showCancelButton(row.item)) ? _c('g-button-ujarak', {
          directives: [{
            name: "confirm",
            rawName: "v-confirm",
            value: ({
              ok: function (retorno) { return _vm.cancelar(retorno, row.item); },
              cancel: _vm.doNothing,
              message: 'Deseja <b>CANCELAR</b> a solicitação de ' + '<font color=' + 'red' + '>' + row.item.tipo_solicitacao + '</font>' + '? <br><br> - ID: ' + '<i>' + '<font color=' + '#00008b' + '>' + row.item.id + '</font>' + '</i>' +
                '<br> - Projeto: ' + '<i>' + '<font color=' + '#00008b' + '>' + row.item.projeto + '</font>' + '</i>' + '</i>'
            }),
            expression: "{ok: retorno => cancelar(retorno, row.item), cancel: doNothing,\n                                        message: 'Deseja <b>CANCELAR</b> a solicitação de ' + '<font color=' + 'red' + '>' + row.item.tipo_solicitacao + '</font>' + '? <br><br> - ID: ' + '<i>' + '<font color=' + '#00008b' + '>' + row.item.id + '</font>' + '</i>'\n                                         + '<br> - Projeto: ' + '<i>'  + '<font color=' + '#00008b' + '>' + row.item.projeto + '</font>' + '</i>' + '</i>'}"
          }],
          attrs: {
            "color": "error",
            "size": "button--size-ss",
            "type": "button"
          }
        }, [_c('i', {
          staticClass: "fa fa-times-circle",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Cancelar\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.validaTipoFase(row.item) && _vm.autorizaValidacao(row.item) && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('span', [_c('g-button-ujarak', {
          attrs: {
            "color": "primary",
            "size": "button--size-ss",
            "type": "button"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.onValidate(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-gavel",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Validar\n                        ")]), _vm._v(" "), ((_vm._.has(row.item, 'id_usuario') && _vm._.isNull(row.item.id_usuario)) && row.item.etapa === 'Autorização' && row.item.situacao === 'Em Execução') ? _c('g-button-ujarak', {
          attrs: {
            "color": "primary",
            "size": "button--size-ss",
            "type": "button"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.segueReanalisar(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-undo",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Reanalisar\n                        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), ((_vm._.includes(['Pagamento', 'Prestação de Contas', 'Adiantamento', 'Devolução de Adiantamento', 'Contrapartida', 'Ressarcimento'], row.item.tipo_solicitacao) && row.item.situacao === 'Feito') && _vm.usuarioLogado.userType == 'FUNDACAO' && _vm.acessoReativarLiberacaoRecursos) ? _c('g-button-ujarak', {
          attrs: {
            "color": "warning",
            "size": "button--size-ss",
            "type": "button"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.solicitacaoReativar(row.item)
            }
          },
          model: {
            value: (row.item.id),
            callback: function($$v) {
              _vm.$set(row.item, "id", $$v)
            },
            expression: "row.item.id"
          }
        }, [_c('i', {
          staticClass: "fa fa-play",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Reativar\n                      ")]) : _vm._e(), _vm._v(" "), ((_vm._.includes(['Pagamento', 'Adiantamento', 'Ressarcimento'], row.item.tipo_solicitacao) && row.item.situacao === 'Feito') && _vm.usuarioLogado.userType == 'FUNDACAO' && _vm.acessoReativarLiberacaoRecursos) ? _c('g-button-ujarak', {
          attrs: {
            "color": "dark-primary",
            "size": "button--size-ss",
            "type": "button"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.solicitacaoReativarRemessa(row.item)
            }
          },
          model: {
            value: (row.item.id),
            callback: function($$v) {
              _vm.$set(row.item, "id", $$v)
            },
            expression: "row.item.id"
          }
        }, [_c('i', {
          staticClass: "fa fa-repeat",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Reativar Liquidação\n                      ")]) : _vm._e(), _vm._v(" "), (row.item.tipo_solicitacao !== 'Migração') ? _c('g-button-ujarak', {
          attrs: {
            "color": "success",
            "size": "button--size-ss",
            "type": "button"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.show(row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-search",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Visualizar\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType !== 'ENTIDADE' && !_vm._.isNull(_vm._.get(row.item, 'arquivos', null))) ? _c('g-button-ujarak', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large',
              arrow: true
            }),
            expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
          }],
          attrs: {
            "color": (_vm._.has(row.item, 'downloading') ? 'light' : 'dark') + '-primary',
            "size": "button--size-ss",
            "title": '<h6 style=\'text-align: left\'>' + row.item.arquivos + '</h6>'
          },
          nativeOn: {
            "click": function($event) {
              _vm._.has(row.item, 'downloading') || _vm.onDownloadZIP(row.item)
            }
          }
        }, [(_vm._.has(row.item, 'downloading')) ? _c('i', {
          staticClass: "fa fa-refresh fa-spin"
        }) : _c('i', {
          staticClass: "fa fa-download",
          attrs: {
            "aria-hidden": "true"
          }
        })]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (row.item.id && _vm.ehParceiroEstrategico) ? _c('div', [(row.item.tipo_solicitacao !== 'Migração') ? _c('g-button-ujarak', {
          attrs: {
            "color": "success",
            "size": "button--size-ss",
            "type": "button"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.show(row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-search",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Visualizar\n                      ")]) : _vm._e(), _vm._v(" "), (!_vm._.isNull(_vm._.get(row.item, 'arquivos', null))) ? _c('g-button-ujarak', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large',
              arrow: true
            }),
            expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
          }],
          attrs: {
            "color": (_vm._.has(row.item, 'downloading') ? 'light' : 'dark') + '-primary',
            "size": "button--size-ss",
            "title": '<h6 style=\'text-align: left\'>' + row.item.arquivos + '</h6>'
          },
          nativeOn: {
            "click": function($event) {
              _vm._.has(row.item, 'downloading') || _vm.onDownloadZIP(row.item)
            }
          }
        }, [(_vm._.has(row.item, 'downloading')) ? _c('i', {
          staticClass: "fa fa-refresh fa-spin"
        }) : _c('i', {
          staticClass: "fa fa-download",
          attrs: {
            "aria-hidden": "true"
          }
        })]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "modal-content",
          staticStyle: {
            "z-index": "10000"
          }
        }, [_c('modal', {
          staticClass: "topo modal-wrapper",
          attrs: {
            "name": "visualizar",
            "width": "70%",
            "height": "auto",
            "scrollable": true
          }
        }, [_c('div', {
          staticClass: "box-header with-border"
        }, [_c('h3', {
          staticClass: "box-title"
        }, [_c('i', {
          staticClass: "fa fa-caret-right",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Consulta: Solicitação de " + _vm._s(_vm.textoTipo))]), _vm._v(" "), _c('div', {
          attrs: {
            "align": "right"
          }
        }, [_c('b-button', {
          staticClass: "btn btn-warning btn-sm btn-flat",
          attrs: {
            "type": "button",
            "data-dismiss": "alert",
            "aria-hidden": "true"
          },
          on: {
            "click": function($event) {
              return _vm.hide()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-close",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("  Fechar ")])], 1)]), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-sm-12"
        }, [_c('form', {
          attrs: {
            "name": "frmSearch",
            "novalidate": ""
          }
        }, [_c('div', {
          staticClass: "form-group required"
        }, [_c('div', {
          staticClass: "col-md-6 col-md-offset-1"
        }, [_c('dl', {
          staticClass: "proposal-definition-list"
        }, [_c('dt', [_vm._v("Projeto: ")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.num) + " - " + _vm._s(_vm.prop))]), _vm._v(" "), _c('dt', [_vm._v("Tipo de Solicitação:")]), _vm._v(" "), _c('dd', [_c('span', [_vm._v(_vm._s(_vm.textoTipo))])])])]), _vm._v(" "), _c('div', {
          staticClass: "col-md-5"
        }, [_c('dl', {
          staticClass: "proposal-definition-list"
        }, [_c('dt', [_vm._v("Etapa: ")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.etapaHist))]), _vm._v(" "), _c('dt', [_vm._v("Situação:")]), _vm._v(" "), _c('dd', [_c('span', [_vm._v(_vm._s(_vm.situacao))])])])])])])])]), _vm._v(" "), (_vm.textoTipo === 'Adiantamento' && _vm.situacao !== 'Cancelado') ? _c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-sm-12"
        }, [_c('form', {
          attrs: {
            "name": "frmSearch",
            "novalidate": ""
          }
        }, [_c('div', {
          staticClass: "form-group required"
        }, [_c('div', {
          staticClass: "col-md-6 col-md-offset-1"
        }, [_c('dl', {
          staticClass: "proposal-definition-list"
        }, [_c('dt', [_vm._v("Dados Bancários: ")]), _vm._v(" "), _c('dd', [_c('span', [_vm._v("Banco: " + _vm._s(_vm.dadosBancariosAdiantamento.banco))])]), _vm._v(" "), _c('dd', [_c('span', [_vm._v("Agência/Conta: " + _vm._s(_vm.dadosBancariosAdiantamento.agencia) + " / " + _vm._s(_vm.dadosBancariosAdiantamento.conta))])]), _vm._v(" "), _c('dd', [_c('span', [_vm._v("Tipo de Conta: " + _vm._s(_vm.dadosBancariosAdiantamento.tipo == 1 ? 'Conta Corrente' : 'Conta Poupança'))])])])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-12"
        }, [_c('div', {
          staticClass: "box-body"
        }, [(_vm.textoTipo === 'Pagamento' || _vm.textoTipo === 'Ressarcimento' || _vm.textoTipo === 'Contrapartida' || _vm.textoTipo === 'Prestação de Contas') ? _c('div', {
          staticClass: "box-header with-border"
        }, [_c('h3', {
          staticClass: "box-title"
        }, [_vm._v("Cronograma Físico-Financeiro")])]) : _vm._e(), _vm._v(" "), (_vm.textoTipo === 'Devolução de Adiantamento' || _vm.textoTipo === 'Prestação de Contas') ? _c('div', {
          staticClass: "box-header with-border"
        }, [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "box-header with-border"
        }, [_c('h3', {
          staticClass: "box-title"
        }, [_vm._v("Solicitações concedidas")])]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-12"
        }, [_c('div', {
          staticClass: "table-responsive"
        }, [_c('table', {
          staticClass: "table table-condensed table-bordered table-striped"
        }, [_c('thead', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('tr', [_c('td', [_vm._v("ID")]), _vm._v(" "), _c('td', [_vm._v("Processo de solicitação em andamento")]), _vm._v(" "), _c('td', [_vm._v("Valor liberado")]), _vm._v(" "), _c('td', [_vm._v("Valor não solicitado")]), _vm._v(" "), _c('td', [_vm._v("Data limite para prestação de contas")]), _vm._v(" "), _c('td', [_vm._v("Data da última prestação de contas")])])]), _vm._v(" "), _c('tbody', [_c('tr', {
          directives: [{
            name: "repeat",
            rawName: "v-repeat",
            value: (_vm.adiantamento),
            expression: "adiantamento"
          }]
        }, [_c('td', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(_vm.adiantamento.id))]), _vm._v(" "), _c('td', {
          staticClass: "text-center",
          attrs: {
            "data-title": "'Processo de solicitação em andamento'",
            "sortable": "'projectName'"
          }
        }, [_vm._v(_vm._s(_vm.adiantamento.projectName + ' - ' + _vm.adiantamento.createDate))]), _vm._v(" "), _c('td', {
          staticClass: "text-center",
          attrs: {
            "data-title": "'Valor liberado'",
            "sortable": "'valueReleased'"
          }
        }, [_vm._v(_vm._s(_vm._f("real")(_vm.adiantamento.totalValue)))]), _vm._v(" "), _c('td', {
          staticClass: "text-center",
          attrs: {
            "data-title": "'Valor não solicitado'",
            "sortable": "'totalValueBalance'"
          }
        }, [_vm._v(_vm._s(_vm._f("real")(_vm.adiantamento.totalValueBalance)))]), _vm._v(" "), _c('td', {
          staticClass: "text-center",
          attrs: {
            "data-title": "'Data limite para prestação de contas'",
            "sortable": "'datLimAcc'"
          }
        }, [_vm._v(_vm._s(_vm.adiantamento.limitDate))]), _vm._v(" "), _c('td', {
          staticClass: "text-center",
          attrs: {
            "data-title": "'Data da última prestação de contas'",
            "sortable": "'lastDatLimAcc'"
          }
        }, [_vm._v(_vm._s(_vm.adiantamento.lastParcelDate || _vm.adiantamento.data_ultima_prestacao))])])]), _vm._v(" "), _c('tr', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: ((_vm.adiantamento.length === 0)),
            expression: "(adiantamento.length === 0)"
          }]
        }, [_c('td', {
          staticClass: "text-center",
          attrs: {
            "colspan": "100%"
          }
        }, [_vm._v("Nenhum registro encontrado!")])])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "row",
          staticStyle: {
            "overflow": "auto"
          }
        }, [(_vm.textoTipo === 'Pagamento' || _vm.textoTipo === 'Ressarcimento' || _vm.textoTipo === 'Contrapartida' || _vm.textoTipo === 'Prestação de Contas') ? _c('div', {
          staticClass: "col-md-12 financial-physical-schedule",
          attrs: {
            "align": "center"
          }
        }, [_c('table', {
          staticClass: "table table-condensed table-bordered"
        }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Item")]), _vm._v(" "), (_vm.textoTipo === 'Pagamento' || _vm.textoTipo === 'Ressarcimento') ? _c('th', [_vm._v("Tipo")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Quantidade")]), _vm._v(" "), _c('th', [_vm._v("Valor Total")]), _vm._v(" "), _c('th', [_vm._v("Quantidade a solicitar")]), _vm._v(" "), _c('th', [_vm._v("Valor a solicitar")]), _vm._v(" "), (_vm.textoTipo == 'Contrapartida') ? _c('th', [_vm._v("Economicidade")]) : _vm._e(), _vm._v(" "), _c('th', {
          attrs: {
            "uib-tooltip": "Quantidade a comprovar calculada a partir do somatório de todas as solicitações aprovadas ou em andamento",
            "tooltip-append-to-body": "true"
          }
        }, [_vm._v("Quantidade a comprovar")]), _vm._v(" "), _c('th', {
          attrs: {
            "uib-tooltip": "Valor a comprovar calculado a partir do somatório de todas as solicitações aprovadas ou em andamento",
            "tooltip-append-to-body": "true"
          }
        }, [_vm._v("Valor a comprovar")])])]), _vm._v(" "), _c('tbody', {
          staticClass: "overlay"
        }, _vm._l((_vm.montaCronograma), function(item, index) {
          return _c('tr', {
            key: index,
            attrs: {
              "item": item
            }
          }, [_c('td', [_vm._v(_vm._s(item.Item) + " - " + _vm._s(item.Item_Descricao)), _c('br'), _c('div', [_vm._v("#" + _vm._s(item.Id_item) + " " + _vm._s(item.Item_Observacao))])]), _vm._v(" "), (_vm.textoTipo === 'Pagamento' || _vm.textoTipo === 'Ressarcimento') ? _c('td', [_vm._v(_vm._s(item.Item_Tipo))]) : _vm._e(), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [_vm._v(_vm._s(item.Qtde_orcado))]), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [_vm._v(_vm._s(_vm._f("real")(parseFloat(item.Valor_orcado))))]), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [_vm._v(_vm._s(item.Qtde_solicitado))]), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [_vm._v(_vm._s(_vm._f("real")(parseFloat(item.Valor_solicitado))))]), _vm._v(" "), (_vm.textoTipo == 'Contrapartida') ? _c('td', {
            staticClass: "text-center"
          }, [_c('label', {
            staticClass: "checkbox-inline new-control new-control-checkbox",
            staticStyle: {
              "margin-bottom": "10px"
            }
          }, [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (item.Economicidade),
              expression: "item.Economicidade"
            }],
            attrs: {
              "disabled": true,
              "type": "checkbox",
              "true-value": 1
            },
            domProps: {
              "checked": Array.isArray(item.Economicidade) ? _vm._i(item.Economicidade, null) > -1 : _vm._q(item.Economicidade, 1)
            },
            on: {
              "change": function($event) {
                var $$a = item.Economicidade,
                  $$el = $event.target,
                  $$c = $$el.checked ? (1) : (false);
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v);
                  if ($$el.checked) {
                    $$i < 0 && (_vm.$set(item, "Economicidade", $$a.concat([$$v])))
                  } else {
                    $$i > -1 && (_vm.$set(item, "Economicidade", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
                  }
                } else {
                  _vm.$set(item, "Economicidade", $$c)
                }
              }
            }
          }), _vm._v(" "), _c('div', {
            staticClass: "new-control-indicator"
          })])]) : _vm._e(), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [_vm._v(_vm._s(item.Qtde_saldo))]), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [_vm._v(_vm._s(_vm._f("real")(parseFloat(item.Valor_saldo))))])])
        }), 0), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
          staticStyle: {
            "border-right": "none"
          },
          attrs: {
            "colspan": "4"
          }
        }, [_vm._v("Valor total da solicitação: ")]), _vm._v(" "), _c('td', {
          staticClass: "text-right",
          staticStyle: {
            "border-left": "none"
          },
          attrs: {
            "colspan": "4"
          }
        }, [_vm._v(_vm._s(_vm._f("real")(parseFloat(_vm.valorTotal))))])])])])]) : _vm._e()]), _vm._v(" "), (_vm.textoTipo === 'Adiantamento') ? _c('div', {
          staticClass: "row",
          staticStyle: {
            "overflow": "auto"
          }
        }, [_c('div', {
          staticClass: "box-header with-border"
        }, [_c('h3', {
          staticClass: "box-title"
        }, [_vm._v(" Solicitação de Adiantamento\n                                  ")])]), _vm._v(" "), _c('div', {
          staticClass: "col-md-12 financial-physical-schedule"
        }, [_c('table', {
          staticClass: "table table-condensed table-bordered",
          attrs: {
            "align": "center"
          }
        }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Parcela")]), _vm._v(" "), _c('th', [_vm._v("Recurso")]), _vm._v(" "), _c('th', [_vm._v("Fase")]), _vm._v(" "), _c('th', [_vm._v("Valor total por fase")]), _vm._v(" "), _c('th', [_vm._v("Valor a solicitar por fase")]), _vm._v(" "), _c('th', [_vm._v("Saldo restante por fase")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.itemAdt), function(item, index) {
          return _c('tr', {
            key: index,
            attrs: {
              "disabled": "true"
            }
          }, [_c('td', [_vm._v(_vm._s(item.parcela))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.origem))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.origem === 1 ? 'FUNDACAO' : 'PARCEIRO ESTRATÉGICO'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("real")(item.valor)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("real")(_vm.vlrAdt)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("real")(item.valor - (_vm.vlrAdt))))])])
        }), 0)])])]) : _vm._e()])])]), _vm._v(" "), _c('div', [_c('div', {
          staticClass: "box-body"
        }, [(_vm.textoTipo === 'Pagamento' || _vm.textoTipo === 'Ressarcimento' || _vm.textoTipo === 'Prestação de Contas') ? _c('div', [_c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('fieldset', {
          attrs: {
            "disabled": "true"
          }
        }, [(_vm.textoTipo === 'Pagamento' || _vm.textoTipo === 'Ressarcimento' || _vm.textoTipo === 'Prestação de Contas') ? _c('div', [_c('div', {
          staticClass: "box-header with-border"
        }, [_c('h3', {
          staticClass: "box-title"
        }, [_vm._v("Documento fiscal")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-6"
        }, [_c('div', [_c('label', {
          staticClass: "control-label col-md-4",
          attrs: {
            "for": "numero"
          }
        }, [_vm._v("Número nota fiscal:")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-7 "
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.numero),
            expression: "numero"
          }],
          staticClass: "form-control text-right",
          attrs: {
            "id": "numero",
            "name": "numero",
            "type": "text",
            "maxlength": "20",
            "disabled": "true"
          },
          domProps: {
            "value": (_vm.numero)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.numero = $event.target.value
            }
          }
        })])])]), _vm._v(" "), _c('div', {
          staticClass: "col-md-6"
        }, [_c('div', [_c('label', {
          staticClass: "control-label col-md-4",
          attrs: {
            "id": "emissao",
            "for": "emissao"
          }
        }, [_vm._v("Data de emissão do documento:")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-7 "
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.emissao),
            expression: "emissao"
          }],
          staticClass: "form-control",
          attrs: {
            "name": "emissao",
            "type": "date"
          },
          domProps: {
            "value": (_vm.emissao)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.emissao = $event.target.value
            }
          }
        })])])]), _vm._v(" "), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
          staticClass: "col-md-6"
        }, [_c('div', [_c('label', {
          staticClass: "control-label col-md-4",
          attrs: {
            "for": "serie"
          }
        }, [_vm._v("Série:")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-7 "
        }, [_c('select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.serie),
            expression: "serie"
          }],
          staticClass: "form-control",
          attrs: {
            "id": "serie",
            "name": "serie",
            "required": ""
          },
          on: {
            "change": function($event) {
              var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
                return o.selected
              }).map(function(o) {
                var val = "_value" in o ? o._value : o.value;
                return val
              });
              _vm.serie = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
            }
          }
        }, [_c('option', {
          attrs: {
            "value": "NOTA_FISCAL"
          }
        }, [_vm._v("1 - Nota fiscal")]), _vm._v(" "), _c('option', {
          attrs: {
            "value": "RECIBO_PAGAMENTO_AUTONOMO"
          }
        }, [_vm._v("10 - Recibo de pagamento a autônomo")]), _vm._v(" "), _c('option', {
          attrs: {
            "value": "DOCUMENTO_NAO_FISCAL"
          }
        }, [_vm._v("DNF - Documento não fiscal")])])])])]), _vm._v(" "), (_vm.validade) ? _c('div', {
          staticClass: "col-md-6"
        }, [_c('div', [_c('label', {
          staticClass: "control-label col-md-4",
          attrs: {
            "for": "validade"
          }
        }, [_vm._v("Data de validade do documento:")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-7 "
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.validade),
            expression: "validade"
          }],
          staticClass: "form-control",
          attrs: {
            "id": "validade",
            "name": "expirationDate",
            "type": "date"
          },
          domProps: {
            "value": (_vm.validade)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.validade = $event.target.value
            }
          }
        })])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.textoTipo === 'Pagamento' || _vm.textoTipo === 'Ressarcimento' || _vm.textoTipo === 'Prestação de Contas') ? _c('div', [_c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('fieldset', {
          attrs: {
            "disabled": "true"
          }
        }, [(_vm.textoTipo === 'Pagamento' || _vm.textoTipo === 'Ressarcimento' || _vm.textoTipo === 'Prestação de Contas') ? _c('div', [_c('div', {
          staticClass: "box-header with-border"
        }, [_c('h3', {
          staticClass: "box-title"
        }, [_vm._v("Forma de Pagamento")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-6"
        }, [_c('div', [_c('label', {
          staticClass: "control-label col-md-4",
          attrs: {
            "for": "forma"
          }
        }, [_vm._v("Forma de pagamento:")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-7 "
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.forma),
            expression: "forma"
          }],
          staticClass: "form-control text-right",
          attrs: {
            "id": "forma",
            "name": "forma",
            "type": "text",
            "maxlength": "20",
            "disabled": "true"
          },
          domProps: {
            "value": (_vm.forma)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.forma = $event.target.value
            }
          }
        })])])]), _vm._v(" "), _c('div', {
          staticClass: "col-md-6"
        }, [_c('div', [_c('label', {
          staticClass: "control-label col-md-4",
          attrs: {
            "for": "prioridade"
          }
        }, [_vm._v("Pagamento Prioritário:")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-7 "
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.prioridade),
            expression: "prioridade"
          }],
          staticClass: "form-control text-right",
          attrs: {
            "id": "prioridade",
            "name": "prioridade",
            "type": "text",
            "maxlength": "20",
            "ng-disabled": "true"
          },
          domProps: {
            "value": (_vm.prioridade)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.prioridade = $event.target.value
            }
          }
        })])])])])]) : _vm._e()]), _vm._v(" "), (_vm.textoTipo === 'Pagamento' || _vm.textoTipo === 'Ressarcimento' || _vm.textoTipo === 'Prestação de Contas') ? _c('div', [_c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('fieldset', {
          attrs: {
            "disabled": "true"
          }
        }, [(_vm.textoTipo === 'Pagamento' || _vm.textoTipo === 'Ressarcimento' || _vm.textoTipo === 'Prestação de Contas') ? _c('div', [_c('div', {
          staticClass: "box-header with-border"
        }, [_c('h3', {
          staticClass: "box-title"
        }, [_vm._v("Fornecedor")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-6"
        }, [_c('div', [_c('label', {
          staticClass: "control-label col-md-4",
          attrs: {
            "for": "tipoPessoa"
          }
        }, [_vm._v("Tipo de pessoa:")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-7 "
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.tipoPessoa),
            expression: "tipoPessoa"
          }],
          staticClass: "form-control text-right",
          attrs: {
            "id": "tipoPessoa",
            "name": "fornecedorTipo",
            "type": "text",
            "maxlength": "20"
          },
          domProps: {
            "value": (_vm.tipoPessoa)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.tipoPessoa = $event.target.value
            }
          }
        })])])]), _vm._v(" "), _c('div', {
          staticClass: "col-md-6"
        }, [_c('div', [_c('label', {
          staticClass: "control-label col-md-4"
        }, [_vm._v(_vm._s(_vm.texto))]), _vm._v(" "), _c('div', {
          staticClass: "col-md-7 "
        }, [(_vm.fornecedor.identificador.length > 11) ? _c('span', [_vm._v(_vm._s(_vm._f("cnpj")(_vm.fornecedor.identificador)))]) : _c('span', [_vm._v(_vm._s(_vm._f("cpf")(_vm.fornecedor.identificador)))])])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
          staticClass: "col-md-6"
        }, [_c('div', [_c('label', {
          staticClass: "control-label col-md-4",
          attrs: {
            "for": "nomeFornecedor"
          }
        }, [_vm._v("Nome:")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-7 "
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.nomeFornecedor),
            expression: "nomeFornecedor"
          }],
          staticClass: "form-control text-right",
          attrs: {
            "id": "nomeFornecedor",
            "name": "nomeFornecedor",
            "type": "text",
            "maxlength": "20",
            "disabled": "true"
          },
          domProps: {
            "value": (_vm.nomeFornecedor)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.nomeFornecedor = $event.target.value
            }
          }
        })])])]), _vm._v(" "), _c('div', {
          staticClass: "col-md-6"
        }, [_c('div', [_c('label', {
          staticClass: "control-label col-md-4",
          attrs: {
            "for": "endereco"
          }
        }, [_vm._v("Endereço:")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-7 "
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.endereco),
            expression: "endereco"
          }],
          staticClass: "form-control text-right",
          attrs: {
            "id": "endereco",
            "name": "endereco",
            "type": "text",
            "maxlength": "20",
            "disabled": "true"
          },
          domProps: {
            "value": (_vm.endereco)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.endereco = $event.target.value
            }
          }
        })])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
          staticClass: "col-md-6"
        }, [_c('div', [_c('label', {
          staticClass: "control-label col-md-4",
          attrs: {
            "for": "cep"
          }
        }, [_vm._v("CEP:")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-7 "
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.cep),
            expression: "cep"
          }, {
            name: "mask",
            rawName: "v-mask",
            value: (['#####-###']),
            expression: "['#####-###']"
          }],
          staticClass: "form-control text-right",
          attrs: {
            "id": "cep",
            "name": "cep",
            "type": "text",
            "maxlength": "20",
            "disabled": "true"
          },
          domProps: {
            "value": (_vm.cep)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.cep = $event.target.value
            }
          }
        })])])])])]) : _vm._e()])]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), (_vm.textoTipo === 'Pagamento' || _vm.textoTipo === 'Ressarcimento' || _vm.textoTipo === 'Prestação de Contas') ? _c('div', [_c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('fieldset', {
          attrs: {
            "disabled": "true"
          }
        }, [(_vm._.includes(['Pagamento', 'Ressarcimento'], _vm.textoTipo) && (_vm.banco !== 0)) ? _c('div', [_c('div', {
          staticClass: "box-header with-border"
        }, [_c('h3', {
          staticClass: "box-title"
        }, [_vm._v("Dados bancários")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-6"
        }, [_c('label', {
          staticClass: "control-label col-md-4"
        }, [_vm._v("Banco:")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-7 "
        }, [_c('select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.banco),
            expression: "banco"
          }],
          staticClass: "form-control",
          attrs: {
            "name": "banco",
            "for": "banco"
          },
          on: {
            "change": function($event) {
              var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
                return o.selected
              }).map(function(o) {
                var val = "_value" in o ? o._value : o.value;
                return val
              });
              _vm.banco = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
            }
          }
        }, [_c('option', {
          attrs: {
            "disabled": ""
          }
        }, [_vm._v("Escolha um banco")]), _vm._v(" "), _vm._l((_vm.bancosMain), function(banco) {
          return _c('option', {
            domProps: {
              "value": banco.value
            }
          }, [_vm._v(_vm._s(banco.value + ' - ' + banco.label))])
        }), _vm._v(" "), _c('option', {
          attrs: {
            "disabled": ""
          }
        }, [_vm._v("--------------------------------------------------------------------------")]), _vm._v(" "), _vm._l((_vm.bancos), function(banco) {
          return _c('option', {
            domProps: {
              "value": banco.value
            }
          }, [_vm._v(_vm._s(banco.value + ' - ' + banco.label))])
        })], 2)])]), _vm._v(" "), _c('div', {
          staticClass: "col-md-6"
        }, [_c('div', [_c('label', {
          staticClass: "control-label col-md-4",
          attrs: {
            "for": "agencia"
          }
        }, [_vm._v("Agência:")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-7 "
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.agencia),
            expression: "agencia"
          }],
          staticClass: "form-control text-right",
          attrs: {
            "id": "agencia",
            "name": "agencia",
            "pattern": "/[0-9]{4}\\-{1}[0-9X]/",
            "type": "text",
            "maxlength": "20",
            "ng-disabled": "true"
          },
          domProps: {
            "value": (_vm.agencia)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.agencia = $event.target.value
            }
          }
        })])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
          staticClass: "col-md-6"
        }, [_c('div', [_c('label', {
          staticClass: "control-label col-md-4",
          attrs: {
            "for": "conta"
          }
        }, [_vm._v("Conta Corrente:")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-7 "
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.conta),
            expression: "conta"
          }],
          staticClass: "form-control text-right",
          attrs: {
            "id": "conta",
            "name": "conta",
            "pattern": "/[0-9]{1,11}\\-{1}([0-9]{1,2}$|\\X{1}$)/",
            "type": "text",
            "maxlength": "20",
            "ng-disabled": "true"
          },
          domProps: {
            "value": (_vm.conta)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.conta = $event.target.value
            }
          }
        })])])])])]) : _vm._e()]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm._.includes(['Pagamento', 'Ressarcimento', 'Prestação de Contas', 'Contrapartida'], _vm.textoTipo)) ? _c('div', [_c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm._.includes(['Pagamento', 'Ressarcimento', 'Prestação de Contas', 'Contrapartida'], _vm.textoTipo)) ? _c('div', {
          staticClass: "col-md-12"
        }, [_c('fieldset', {
          attrs: {
            "disabled": "true"
          }
        }, [_c('div', {
          staticClass: "box-header with-border"
        }, [_c('h3', {
          staticClass: "box-title"
        }, [_vm._v("Documentos de solicitação de " + _vm._s(_vm.textoTipo))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('upload-documentos-php', {
          attrs: {
            "name": "declaracao",
            "propDocumentos": _vm.documentosAnexo,
            "documentTypes": []
          }
        })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.textoTipo === 'Adiantamento' || _vm.textoTipo === 'Devolução de Adiantamento') ? _c('div', {
          staticClass: "col-md-12 financial-physical-schedule"
        }, [_c('fieldset', {
          attrs: {
            "disabled": "true"
          }
        }, [_c('div', {
          staticClass: "box-header with-border"
        }, [_c('h3', {
          staticClass: "box-title"
        }, [_vm._v("Documentos de solicitação de " + _vm._s(_vm.textoTipo))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('upload-documentos-php', {
          attrs: {
            "name": "declaracao",
            "propDocumentos": _vm.documentosAnexo,
            "documentTypes": []
          }
        })], 1)]), _vm._v(" "), _c('div', {
          attrs: {
            "align": "center"
          }
        })]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "col-md-12"
        }, [(_vm.historicoBack && !_vm._.isNull(_vm.historicoBack) && !_vm._.isEmpty(_vm.historicoBack)) ? _c('div', {
          staticClass: "box box-widget"
        }, [_c('div', {
          staticClass: "box-header with-border"
        }, [_c('h3', {
          staticClass: "box-title"
        }, [_vm._v("Histórico de solicitação")])]), _vm._v(" "), (_vm.historicoBack && !_vm._.isNull(_vm.historicoBack) && !_vm._.isEmpty(_vm.historicoBack)) ? _c('historico-solicitacao-pagamento', {
          key: _vm.historicoBack.length,
          attrs: {
            "propsValidacao": _vm.validacao,
            "propsHistorico": _vm.historicoBack
          }
        }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.dataMenor === true || (!_vm.historicoBack || _vm._.isNull(_vm.historicoBack) || _vm._.isEmpty(_vm.historicoBack))) ? _c('div', {
          staticClass: "text-left box-header"
        }, [(_vm.esconderHistorico === false) ? _c('a', {
          attrs: {
            "href": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.esconderHistorico = true
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-caret-down",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Mostrar histórico antigo")]) : _vm._e(), _vm._v(" "), (_vm.esconderHistorico === true) ? _c('a', {
          attrs: {
            "href": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.esconderHistorico = false
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-caret-up",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Ocultar histórico antigo")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.esconderHistorico === true && _vm.dataMenor === true || (!_vm.historicoBack || _vm._.isNull(_vm.historicoBack) || _vm._.isEmpty(_vm.historicoBack))) ? _c('div', {
          staticClass: "col-md-8"
        }, [_c('div', {
          staticClass: "box box-widget"
        }, [_c('div', {
          staticClass: "box-header with-border"
        }, [_c('h3', {
          staticClass: "box-title"
        }, [_vm._v("Histórico Antigo")])]), _vm._v(" "), _c('historico-antigo', {
          key: _vm.historicoAnt.length,
          attrs: {
            "propsValidacao": _vm.validacao,
            "propsHistorico": _vm.historicoAnt
          }
        })], 1)]) : _vm._e()])])])], 1)]
      }
    }], null, false, 432091264)
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "8",
      "right": ""
    }
  }, [_c('b-pagination', {
    staticClass: "my-3",
    attrs: {
      "total-rows": _vm.table.totalRows,
      "per-page": _vm.table.perPage
    },
    model: {
      value: (_vm.table.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.table, "currentPage", $$v)
      },
      expression: "table.currentPage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.show),
      expression: "loading.show"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])], 1)])])])])])])])])]) : (_vm.visibleForm) ? _c('div', [(_vm._.includes(['Pagamento', 'Ressarcimento'], _vm.textoTipo)) ? _c('fieldset', [_c('form-validacao-pagamento', {
    attrs: {
      "propsNota": _vm.nota,
      "propsValidacao": _vm.validacao,
      "propsHistorico": _vm.historicoTarefas
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.textoTipo === 'Contrapartida') ? _c('fieldset', [_c('form-validacao-contrapartida', {
    attrs: {
      "propsNota": _vm.nota,
      "propsValidacao": _vm.validacao
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.textoTipo === 'Prestação de Contas') ? _c('fieldset', [_c('form-validacao-prestacao-contas', {
    attrs: {
      "propsNota": _vm.nota,
      "propsValidacao": _vm.validacao
    }
  })], 1) : _vm._e()]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-icon-warning-sign",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('strong', [_vm._v("Atenção:")]), _vm._v(" as solicitações que estão em revisão pela entidade e não tiverem retorno para a Fundação BB serão canceladas automaticamente após 30 (trinta) dias a contar da data de devolução para revisão.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Consulta de Solicitações")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ae068130!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/solicitacoes/ListaSolicitacao.vue
// module id = 2052
// module chunks = 1